import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import CourseLandingView from "@/components/shared/CourseLandingView";
import { useSeo } from "@/hooks/useSeo";
import { fetchCourse } from "@/lib/coursesApi";

export default function CourseLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    setCourse(null);
    setNotFound(false);
    fetchCourse(slug)
      .then((data) => {
        if (!active) return;
        if (data?.redirect) {
          navigate(data.redirect, { replace: true });
          return;
        }
        setCourse(data);
      })
      .catch(() => active && setNotFound(true));
    return () => {
      active = false;
    };
  }, [slug, navigate]);

  useSeo({
    title: course?.seoTitle || course?.name || "Course",
    description: course?.seoDescription || course?.shortDescription || "",
    path: `/courses/${slug}`,
    image: course?.ogImage,
    canonical: course?.canonical,
  });

  if (notFound)
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
        <h1 className="font-heading text-3xl text-navy">Course not found</h1>
        <a href="/courses" className="text-orange underline">Browse all courses</a>
      </div>
    );
  if (!course)
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-orange" />
      </div>
    );
  return <CourseLandingView course={course} />;
}
